import ImagePreviewer from '@/components/ImagePreviewer.vue';
export default {
  props: {
    srcs: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ImagePreviewer
  },
  data() {
    return {};
  },
  computed: {
    srcArrays() {
      return this.srcs.map(src => ({
        src,
        key: new Date().getTime() + Math.random()
      }));
    }
  },
  methods: {
    handlePreview(images, image) {
      const startPosition = images.findIndex(url => url === image);
      this.$refs.imagePreviewer.open({
        images,
        startPosition
      });
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};